import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const ContentCtx = createContext(null);

const FALLBACK = {
  siteContent: {
    hero: {
      tagline: "Hyderabad · India",
      title: "We Build Games<br/>That Glitch Reality",
      subtitle: "Casual & arcade game development studio.",
      ctaPrimary: "Start a Project",
      ctaSecondary: "See Our Games",
      lineColors: ["#c8ff2a", "#ff2a8f", "#2ad6ff", "#ffffff"],
    },
    services: { label: "", title: "", subtitle: "", items: [] },
    contact: { address: "", phone: "", email: "" },
    footer: { text: "Glitch Game Labs" },
  },
  sections: {
    testimonials: { enabled: false, items: [] },
    clientwork: { enabled: false, items: [] },
    clients: { enabled: false, items: [] },
    games: { enabled: false, items: [] },
    assets: { enabled: false, items: [] },
  },
};

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(FALLBACK);
  const [loading, setLoading] = useState(true);

  const fetchContent = useCallback(async () => {
    try {
      const { data } = await api.get("/content");
      const sc = data.siteContent || {};
      // Deep-merge hero so new fields like lineColors get defaults.
      setContent({
        siteContent: {
          ...FALLBACK.siteContent,
          ...sc,
          hero: { ...FALLBACK.siteContent.hero, ...(sc.hero || {}) },
        },
        sections: { ...FALLBACK.sections, ...(data.sections || {}) },
      });
    } catch (e) {
      console.error("content load failed", e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchContent();
  }, [fetchContent]);

  return (
    <ContentCtx.Provider value={{ ...content, loading, refresh: fetchContent }}>
      {children}
    </ContentCtx.Provider>
  );
};

export const useContent = () => useContext(ContentCtx);
